<div class="flex flex-col gap-4 w-full">
  <p-card header="Donor Care Report">
    <div [formGroup]="searchForm">
      <app-saved-search 
        searchType="donorCareReport"
        [loading]="loading()"
        searchButtonText="Run Report"
        (searchClick)="onSearch()">
        <div class="donor-care-form-row flex flex-row gap-6 items-end w-full mb-4">
          <div class="flex flex-col gap-2">
            <label for="dateRange" class="font-medium">Date Range:</label>
            <app-date-range-picker
              id="dateRange"
              formControlName="dateRange"
              [presets]="trimesterPresets">
            </app-date-range-picker>
          </div>
          <div class="flex flex-col gap-2">
            <label for="location" class="font-medium">Location(s):</label>
            <app-location-multi-dropdown
              id="location"
              [options]="locations()"
              formControlName="locationIds"
              placeholder="Select Location(s)"
              styleClass="w-48">
            </app-location-multi-dropdown>
          </div>
        </div>
      </app-saved-search>
    </div>
  </p-card>

  <ng-container *ngIf="loading(); else reportContent">
    <p-card>
      <div class="flex justify-center items-center p-8">
        <div class="text-center">
          <i class="pi pi-spin pi-spinner text-4xl mb-2"></i>
          <p>Loading donor care report data...</p>
        </div>
      </div>
    </p-card>
  </ng-container>
  <ng-template #reportContent>
    @if (!loading() && reportData().length === 0 && searchPerformed()) {
      <p-card>
        <div class="flex justify-center items-center p-8">
          <div class="text-center">
            <fa-icon [icon]="icons.solid.faMagnifyingGlass" class="text-4xl mb-2 text-blue-500"></fa-icon>
            <p class="text-lg font-medium">No donor care data found</p>
            <p class="text-gray-600">Try adjusting your search criteria or date range.</p>
          </div>
        </div>
      </p-card>
    }
    @if (reportData().length > 0) {
      <p-card>
        <p-table 
          #donorCareTable
          [value]="reportData()" 
          [paginator]="true" 
          [rows]="10"
          [showCurrentPageReport]="true"
          [tableStyle]="{'min-width': '100%'}"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [rowsPerPageOptions]="[10,25, 50, 100, 1000]"
          styleClass="p-datatable-gridlines"
          [globalFilterFields]="['locationName', 'partnerName', 'quarter', 'year']"
          [resizableColumns]="true"
          [scrollable]="true"
          [scrollHeight]="layoutService.maxPaginatedTableScrollHeight()"
          sortMode="multiple"
          exportFilename="Donor_Care_Report">
          <ng-template pTemplate="caption">
            <app-table-caption [table]="donorCareTable" [showClearFilters]="true" ></app-table-caption>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <app-table-headers [columns]="columns()"></app-table-headers>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <app-table-columns [columns]="columns()" [data]="item"></app-table-columns>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="9" class="text-center p-4">
                No donor care report data found for the selected criteria.
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-card>
    }
  </ng-template>
</div> 